import React from 'react';
import { Check, Heart, Camera, MessageCircle, Star, Sparkles, Bike, Users, Brain, Activity, Video, FileText, HeartHandshake } from 'lucide-react';
export default function ProgramDetailsFinalClean() {
  return <div className="w-full bg-white text-[#1a1a1a] font-sans overflow-hidden">
      
      {/* СТИЛИ ФОНОВ (из рекомендаций) */}
      <style>{`
        .bg-grow-together {
          background: radial-gradient(circle at 15% 25%, rgba(22,101,52,0.08), transparent 40%),
                      radial-gradient(circle at 85% 75%, rgba(22,101,52,0.06), transparent 45%),
                      linear-gradient(to bottom, #f3f7f4 0%, #ffffff 60%);
          position: relative;
        }
        .bg-grow-together::after {
          content: ""; position: absolute; inset: 0;
          background-image: radial-gradient(rgba(22,101,52,0.03) 1px, transparent 1px);
          background-size: 60px 60px; opacity: 0.4; pointer-events: none;
        }
        .bg-try-free {
          background: radial-gradient(circle at 50% 0%, rgba(255,193,7,0.25), transparent 50%),
                      linear-gradient(135deg, #166534, #1f7a45);
          position: relative; overflow: hidden;
        }
        @keyframes softGlow {
          0% { opacity: 0.4; } 50% { opacity: 0.6; } 100% { opacity: 0.4; }
        }
        .bg-try-free::before {
          content: ""; position: absolute; inset: 0;
          background: radial-gradient(circle, rgba(255,255,255,0.08) 1px, transparent 1px);
          background-size: 40px 40px; animation: softGlow 6s ease-in-out infinite;
        }
        .bg-activities {
          background: linear-gradient(rgba(255,255,255,0.94), rgba(248,251,250,0.96)),
                      url('https://informed-gannet.10web.cloud/wp-content/uploads/2026/04/IMG_8569.png');
          background-size: cover; background-position: center;
        }
      `}</style>

      {/* 1. РАСТЕМ ВМЕСТЕ */}
      

      {/* 2. БОЛЬШЕ ЧЕМ ПРОСТО РЕАБИЛИТАЦИЯ */}
      

      {/* 3. БАЗОВЫЙ ПАКЕТ ГЕРОЙ */}
      

      {/* 4. ПОПРОБУЙТЕ БЕСПЛАТНО */}
      

      {/* 5. ПОСЛЕ ПРОГРАММЫ — ВМЕСТЕ ВПЕРЕД */}
      

      {/* 6. АКТИВНОСТИ НА ПРИРОДЕ */}
      

    </div>;
}